import { type SvgProperties, Svg as SvgUIKit } from "@react-three/uikit";

export interface SvgProps extends SvgProperties {}

export function Svg({ ...props }: SvgProps) {
  return <SvgUIKit display="flex" {...props} />;
}
